import * as Sentry from "@sentry/browser";
import { toast } from "react-toastify";

export const isValidationError = (
  error: any,
): error is { response: { data: { msg: string } }; status: 400 } => {
  return (
    error?.response?.status === 400 &&
    error?.response?.data?.code === "validation_error"
  );
};

export const isNotFoundError = (error: any): boolean => {
  return (
    error?.response?.status === 404 &&
    error?.response?.data?.code === "not_found"
  );
};

export const isPermissionError = (error: any): boolean => {
  return (
    error?.response?.status === 403 &&
    error?.response?.data?.code === "forbidden"
  );
};

export const isVersionOutdatedError = (error: any): boolean => {
  return (
    error?.response?.status === 400 &&
    error?.response?.data?.code === "version_outdated"
  );
};

export const isSmartApplyValidationError = (error: any): boolean => {
  return (
    error?.response?.status === 400 &&
    error?.response?.data?.code === "bad_request" &&
    // FIXME: validation errrorを明示的にcodeで返したほうが良い
    error?.response?.data?.msg === "the procedure is not publishable yet."
  );
};

export const isSmartApplyAccessRestrictionError = (error: any): boolean => {
  return (
    error?.response?.status === 400 &&
    error?.response?.data?.code === "smart_apply_access_restriction_error"
  );
};

export const isTagPriorityDuplicationError = (error: any): boolean => {
  return (
    error?.response?.status === 400 &&
    error?.response?.data?.code ===
      "bad_request.proc_management.tag_priority_duplication_error"
  );
};

export const isTagDuplicateError = (error: any): boolean => {
  return (
    error?.response?.status === 400 &&
    error?.response?.data?.code === "validation_error" &&
    error?.response?.data?.msg ===
      "duplicated name is not allowed for procedure tag"
  );
};

// ReportNonRequiredError
// 予期される、あるいはすでに報告済みのエラーで、あらためて `reportAsyncError` などを呼ばなくてもよいことを示す。
export class ReportNonRequiredError extends Error {}

const shouldReport = (error: any) => {
  if (error instanceof ReportNonRequiredError) {
    return false;
  }
  if (error.response?.status === 401) {
    return false;
  }
  return true;
};

const handleError = (error: any) => {
  if (error.response?.status === 401) {
    handle401Error();
  }
};

const handle401Error = () => {
  toast.error(
    "長時間操作が行われなかったためタイムアウトしました。再度ログインしてください。",
  );
};

export const reportProcManagementRelatedError = (error: any) => {
  handleError(error);

  if (!shouldReport(error)) {
    return;
  }

  const wrappedError = new Error(
    `[proc-management related] ${
      error instanceof Error ? error.message : JSON.stringify(error)
    }`,
  );

  if (process.env.REACT_APP_ENVIRONMENT === "local") {
    alert(wrappedError);
    console.log(wrappedError);
    return;
  }

  const extra =
    typeof error?.response?.data === "object"
      ? { responseBodyStr: JSON.stringify(error.response.data) }
      : undefined;
  Sentry.captureException(wrappedError, { extra });
};
